module.exports = __webpack_public_path__ + "img/image_placeholder.3bb28904.png";